























































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class RentalInfoTable extends Vue {
  @Prop({ required: true })
  private item!: IMachineryRental;
}
